import { Box, Button, Link, Modal, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import SlidingPanel from "react-sliding-side-panel";
import DatePicker from "../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
import SelectDropdownDisable from "../../../Supporting files/SelectDropdownDisable/SelectDropdownDisable";
import BulkUploadForm from "../../Common/BulkUploadFormSP/BulkUploadForm";
import AddKycDocument from "../AddKycDocument/AddKycDocument";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import "../PolicyHistory/PolicyHistory.scss";

function EmployeeDetailProfile() {
  const [fullName, setFullName] = React.useState("");
  const [relationEmployees, setRelationEmployees] = React.useState("");
  const [selectDocument, setSelectDocument] = React.useState("Passport");
  const [regNumber, setRegNumber] = React.useState("UK 07 De 1937");
  const [vehicleType, setVehicleType] = React.useState("Car");
  const [makeModel, setMakeModel] = React.useState("Hyundai i20 Elite");
  const [fuelType, setFuelType] = React.useState("Petrol");
  const [variant, setVariant] = React.useState("1.5 CC ds");
  const [propertyType, setPropertyType] = React.useState("Owned");
  const [propertyAge, setPropertyAge] = React.useState("1-5 Years");
  const [buildingType, setBuildingType] = React.useState("Independent");
  const [streetName, setStreetName] = React.useState("#6, Building");
  const [areaName, setAreaName] = React.useState("Phase 9, Industrial Area");
  const [country, setCountry] = React.useState("India");
  const [state, setState] = React.useState("U.K.");
  const [city, setCity] = React.useState("Dehradun");
  const [zipCode, setZipCode] = React.useState("248001");
  const [regDate, setRegDate] = React.useState<Date | null>(new Date());
  const [policyExpiry, setPolicyExpiry] = React.useState<Date | null>(
    new Date()
  );
  const [previousInsurer, setPreviousInsurer] = React.useState("Bajaj Allianz");

  const [dob, setDob] = React.useState<Date | null>(new Date());
  const [uploadFile, setUploadFile] = React.useState(false);

  const [addKyc, setAddKyc] = React.useState(false);
  const [addFamily, setAddFamily] = React.useState(false);
  const [addVehicle, setAddVehicle] = React.useState(false);
  const [addProperty, setAddProperty] = React.useState(false);
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [expanded, setExpanded] = React.useState<string | false>("panel");

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const relationEmployees_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
  ];

  const selectDocument_data = [
    { key: "Aadhar Card", value: "Aadhar Card" },
    { key: "Passport", value: "Passport" },
  ];
  const vehicleType_data = [
    { key: "Car", value: "Car" },
    { key: "Bike", value: "Bike" },
  ];
  const makeModel_data = [
    { label: "Hyundai i20 Elite", value: "Hyundai i20 Elite" },
    { label: "Hyundai i10", value: "Hyundai i10" },
  ];
  const fuelType_data = [
    { key: "Petrol", value: "Petrol" },
    { key: "Diesel", value: "Diesel" },
  ];
  const variant_data = [
    { label: "1.5 CC ds", value: "1.5 CC ds" },
    { label: "1.5 CC ds", value: "1.5 CC ds" },
  ];
  const previousInsurer_data = [
    { label: "Bajaj Allianz", value: "Bajaj Allianz" },
    { label: "Star", value: "Star" },
  ];
  const propertyType_data = [
    { key: "Owned", value: "Owned" },
    { key: "Owned", value: "Owned" },
  ];
  const propertyAge_data = [
    { label: "1-5 years", value: "1-5 years" },
    { label: "5-10 years", value: "5-10 years" },
  ];
  const buildingType_data = [
    { key: "Independent", value: "Independent" },
    { key: "MultiStory", value: "MultiStory" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
  ];
  const state_data = [
    { label: "U.K.", value: "U.K." },
    { label: "Haryana", value: "Haryana" },
    { label: "Rajasthan", value: "Rajasthan" },
  ];
  const city_data = [
    { label: "Dehradun", value: "Dehradun" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Mohali", value: "Mohali" },
  ];
  const family_data = [
    {
      img: "./images/husband.svg",
      name: "Ashok Patel",
      dob: "(10-10-1999)",
      relation: "(Husband)",
    },
    {
      img: "./images/wife.svg",
      name: "Sunita Patel",
      dob: "(10-10-1999)",
      relation: "(Wife)",
    },
    {
      img: "./images/father.svg",
      name: "Abhi Patel",
      dob: "(10-10-1999)",
      relation: "(Father)",
    },
    {
      img: "./images/mother.svg",
      name: "Neha Patel",
      dob: "(10-10-1999)",
      relation: "(Mother)",
    },
    {
      img: "./images/boy.svg",
      name: "Aayan Patel",
      dob: "(10-10-1999)",
      relation: "(Son)",
    },
    {
      img: "./images/girl.svg",
      name: "Ginni Patel",
      dob: "(10-10-1999)",
      relation: "(Daughter)",
    },
  ];

  const vehicles_data = [
    {
      img: "./images/car_3.svg",
      car_no: "UK-07-DE-2145",
      car_model: "(Hyundai)",
    },
    {
      img: "./images/car_2.svg",
      car_no: "UK-07-DE-2114",
      car_model: "(Maruti)",
    },
    {
      img: "./images/car_1.svg",
      car_no: "UK-07-DE-1452",
      car_model: "(Tata)",
    },
  ];

  const property_data = [
    {
      img: "./images/property1.svg",
      property_name: "Multi Story",
      property_location: "(Dehradun)",
    },
    {
      img: "./images/property2.svg",
      property_name: "Independent",
      property_location: "(Dehradun)",
    },
    {
      img: "./images/property3.svg",
      property_name: "Independent",
      property_location: "(Dehradun)",
    },
  ];

  const emoloyee_family_table = [
    {
      file_name: "621c94f41153e1835257b41b_lead mockup.webp",
      document_type: "Passport",
      description: "Automation Enhancements and ...",
      Date: "30 Jan, 2023",
      time: "11 :30 A.M.",
    },
    {
      file_name: "621c94f41153e1835257b41b_lead mockup.webp",
      document_type: "Passport",
      description: "Automation Enhancements and ...",
      Date: "25 Nov, 2022",
      time: "11 :30 A.M.",
    },
  ];

  return (
    <>
      <Box className="detailSection mt-4">
        <BulkUploadForm
          open_status={uploadFile}
          attrName={setUploadFile}
          value_update={updateMasterState}
        />
        <div className="sectionTitle">
          <h4>Family Details</h4>
          <div className="actionBtns ">
            <Link underline="none" className="redBtn delete" onClick={() => {}}>
              Remove
            </Link>
            <Link underline="none" className="blueBtn edit" onClick={() => {}}>
              Edit
            </Link>

            <Link
              className="rounded_add_icons mr-3"
              sx={{
                textDecoration: "none",
                cursor: "pointer",
              }}
              onClick={() => setAddFamily(true)}
            >
              Add Family Member
            </Link>
          </div>
        </div>
        <Box className="profile_detail">
          {family_data.map((data, index) => (
            <Grid container spacing={3}>
              <Grid className="profileTypeSection">
                <div className="radioBox ">
                  <input
                    type="radio"
                    id="individual"
                    name="plantype"
                    defaultChecked
                  />
                  <label>
                    <img src={data.img} alt="" />
                  </label>

                  <h6>{data.name}</h6>
                  <p>
                    {data.relation} <span>{data.dob}</span>
                  </p>
                </div>
              </Grid>
            </Grid>
          ))}

          {/* table data */}

          <Grid container spacing={3}>
            <Grid xs={12} style={{ textAlign: "end", paddingRight: "0" }}>
              <div className="actionBtns ">
                <Link
                  className="rounded_add_icons mr-3"
                  sx={{
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => setAddKyc(true)}
                >
                  Add KYC Document
                </Link>
              </div>
            </Grid>
            <Grid xs={12}>
              <div className="table">
                <div
                  className="attatchment_table"
                  style={{ overflow: "hidden" }}
                >
                  <ul className="heading">
                    <li>File Name</li>
                    <li>Document Type</li>
                    <li>Description</li>
                    <li>Date</li>
                    <li>Time</li>
                    <li>Actions</li>
                  </ul>

                  {emoloyee_family_table.map((data, index) => (
                    <ul className="subheading">
                      <li>{data.file_name}</li>
                      <li>{data.document_type}</li>
                      <li>{data.description}</li>
                      <li>
                        <p className="date">{data.Date}</p>
                      </li>
                      <li>
                        <p className="time">{data.time}</p>
                      </li>
                      <li
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <Link
                          className="blueBtn download ml-0"
                          sx={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                        ></Link>
                        <Link
                          className="redBtn delete"
                          onClick={() => {
                            setDeleteStatus(true);
                          }}
                          sx={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                        ></Link>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* car details */}
      <Box className="detailSection mt-4">
        <BulkUploadForm
          open_status={uploadFile}
          attrName={setUploadFile}
          value_update={updateMasterState}
        />
        <div className="sectionTitle">
          <h4>Vehicle Details</h4>
          <div className="actionBtns ">
            <Link underline="none" className="redBtn delete" onClick={() => {}}>
              Remove
            </Link>
            <Link underline="none" className="blueBtn edit" onClick={() => {}}>
              Edit
            </Link>

            <Link
              className="rounded_add_icons mr-3"
              sx={{
                textDecoration: "none",
                cursor: "pointer",
              }}
              onClick={() => setAddVehicle(true)}
            >
              Add vehicle
            </Link>
          </div>
        </div>
        <Box className="profile_detail">
          {vehicles_data.map((data, index) => (
            <Grid container spacing={3}>
              <Grid className="profileTypeSection">
                <div className="radioBox ">
                  <input
                    type="radio"
                    id="individual"
                    name="vehicletypes"
                    defaultChecked
                  />
                  <label>
                    <img src={data.img} alt="" />
                  </label>
                  <h6>{data.car_no}</h6>
                  <p>{data.car_model}</p>
                </div>
              </Grid>
            </Grid>
          ))}
          <Grid container spacing={3}>
            <Grid xs={12}>
              <ul className="vehicle_details">
                <li>
                  <p>
                    Vehicle Type<span>Car</span>
                  </p>
                </li>
                <li>
                  <p>
                    Make & Model<span>(Hyundai i20 Elite)</span>
                  </p>
                </li>
                <li>
                  <p>
                    Fuel Type<span>Diesel</span>
                  </p>
                </li>
                <li>
                  <p>
                    Variant<span>1.5 CC Ds</span>
                  </p>
                </li>
                <li>
                  <p>
                    Registration Date<span>01/06/2018</span>
                  </p>
                </li>
                <li>
                  <p>
                    Policy Expiry Date<span>02/05/2022</span>
                  </p>
                </li>
                <li>
                  <p>
                    Previous Insurer<span>HDFC Ergo</span>
                  </p>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* property details */}
      <Box className="detailSection mt-4">
        <BulkUploadForm
          open_status={uploadFile}
          attrName={setUploadFile}
          value_update={updateMasterState}
        />
        <div className="sectionTitle">
          <h4>Property Details</h4>
          <div className="actionBtns ">
            <Link underline="none" className="redBtn delete" onClick={() => {}}>
              Remove
            </Link>
            <Link underline="none" className="blueBtn edit" onClick={() => {}}>
              Edit
            </Link>

            <Link
              className="rounded_add_icons mr-3"
              sx={{
                textDecoration: "none",
                cursor: "pointer",
              }}
              onClick={() => setAddProperty(true)}
            >
              Add Property
            </Link>
          </div>
        </div>
        <Box className="profile_detail">
          {property_data.map((data, index) => (
            <Grid container spacing={3}>
              <Grid className="profileTypeSection">
                <div className="radioBox ">
                  <input
                    type="radio"
                    id="individual"
                    name="propertytype"
                    defaultChecked
                  />
                  <label>
                    <img src={data.img} alt="" />
                  </label>
                  <h6>{data.property_name}</h6>
                  <p>{data.property_location}</p>
                </div>
              </Grid>
            </Grid>
          ))}
          <Grid container spacing={3}>
            <Grid xs={12}>
              <ul className="property_details">
                <li>
                  <p>
                    Property Type<span>Owned</span>
                  </p>
                </li>
                <li>
                  <p>
                    Property Age<span>1-5 Years</span>
                  </p>
                </li>
                <li>
                  <p>
                    Building/Street Name<span>341 valliant tower</span>
                  </p>
                </li>
                <li>
                  <p>
                    Area Name<span>phase 9 industrial area</span>
                  </p>
                </li>
                <li>
                  <p>
                    Country<span>India</span>
                  </p>
                </li>
                <li>
                  <p>
                    State<span>U.K.</span>
                  </p>
                </li>
                <li>
                  <p>
                    Zip Code<span>160062</span>
                  </p>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* Employee KYC Documents */}
      <Box className="detailSection">
        <div className="sectionTitle">
          <h4>Employee KYC Documents</h4>
          <div className="actionBtns ">
            <Link
              className="rounded_add_icons mr-3"
              sx={{
                textDecoration: "none",
                cursor: "pointer",
              }}
              onClick={() => setAddKyc(true)}
            >
              Add KYC Document
            </Link>
          </div>
        </div>
        <AddKycDocument />
      </Box>

      {/* kyc popoup */}
      <SlidingPanel
        type={"right"}
        isOpen={addKyc}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setAddKyc(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">Upload KYC Document</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setAddKyc(false);
                }}
              />
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <div>
              <Grid container spacing={3}>
                <Grid xs={6}>
                  <SelectDropdownDisable
                    class_name="inputField"
                    title="Select Document"
                    value={selectDocument}
                    attrName={setSelectDocument}
                    value_update={updateMasterState}
                    dropdown_data={selectDocument_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={12} className="mb-4 ">
                  <p>Description</p>
                  <textarea
                    className="textareabox"
                    placeholder="Writing here..."
                  ></textarea>
                </Grid>
              </Grid>
              <Grid container spacing={0} className="mb-5">
                <Grid xs={10} className="inputField uploadFile">
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Upload .xl .csv .xls file"
                    variant="outlined"
                    className="textarea"
                  />
                </Grid>
                <Grid xs={2}>
                  <Button variant="contained" className="browsebtn">
                    Browse
                  </Button>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => setAddKyc(false)}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </SlidingPanel>

      {/* family detail popup */}
      <SlidingPanel
        type={"right"}
        isOpen={addFamily}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setAddFamily(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">Add Family Member</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setAddFamily(false);
                }}
              />
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <div>
              <Grid container spacing={3}>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title={"Full Name"}
                    value={fullName}
                    attrName={setFullName}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Relationship with employee"
                    value={relationEmployees}
                    attrName={setRelationEmployees}
                    value_update={updateMasterState}
                    dropdown_data={relationEmployees_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <DatePicker
                    class_name="inputField"
                    title="DOB"
                    value={dob}
                    attrName={setDob}
                    value_update={updateMasterState}
                    error_message="Please enter Date of Birth"
                    warn_status={false}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => setAddFamily(false)}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </SlidingPanel>

      {/* vehicle detail popup */}
      <SlidingPanel
        type={"right"}
        isOpen={addVehicle}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setAddVehicle(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">Add Vehicle</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setAddVehicle(false);
                }}
              />
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <div>
              <Grid container spacing={3}>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title={"Registration Number"}
                    value={regNumber}
                    attrName={setRegNumber}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Vehicle Type"
                    value={vehicleType}
                    attrName={setVehicleType}
                    value_update={updateMasterState}
                    dropdown_data={vehicleType_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Make & Model"
                    value={makeModel}
                    attrName={setMakeModel}
                    value_update={updateMasterState}
                    data={makeModel_data}
                    warn_status={false}
                    error_message="Please select make model"
                  />
                </Grid>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Fuel Type"
                    value={fuelType}
                    attrName={setFuelType}
                    value_update={updateMasterState}
                    dropdown_data={fuelType_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Variant"
                    value={variant}
                    attrName={setVariant}
                    value_update={updateMasterState}
                    data={variant_data}
                    warn_status={false}
                    error_message="Please select variant"
                  />
                </Grid>
                <Grid xs={6}>
                  <DatePicker
                    class_name="inputField"
                    title="Registration Date"
                    value={regDate}
                    attrName={setRegDate}
                    value_update={updateMasterState}
                    error_message="Please enter reg date"
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <DatePicker
                    class_name="inputField"
                    title="Policy Expiry Date"
                    value={policyExpiry}
                    attrName={setPolicyExpiry}
                    value_update={updateMasterState}
                    error_message="Please enter policy expiry"
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Previous Insurer"
                    value={previousInsurer}
                    attrName={setPreviousInsurer}
                    value_update={updateMasterState}
                    data={previousInsurer_data}
                    warn_status={false}
                    error_message="Please select insurer"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => setAddVehicle(false)}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </SlidingPanel>

      {/* proprty detail popup */}
      <SlidingPanel
        type={"right"}
        isOpen={addProperty}
        size={75}
        panelClassName="sliding-panel"
        backdropClicked={() => setAddProperty(false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">Add Property</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <GridCloseIcon
                onClick={() => {
                  setAddProperty(false);
                }}
              />
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <div>
              <Grid container spacing={3}>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Property Type"
                    value={propertyType}
                    attrName={setPropertyType}
                    value_update={updateMasterState}
                    dropdown_data={propertyType_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Property Age"
                    value={propertyAge}
                    attrName={setPropertyAge}
                    value_update={updateMasterState}
                    data={propertyAge_data}
                    warn_status={false}
                    error_message="Please select age"
                  />
                </Grid>
                <Grid xs={12}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Building Type"
                    value={buildingType}
                    attrName={setBuildingType}
                    value_update={updateMasterState}
                    dropdown_data={buildingType_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title={"Building/Street Name"}
                    value={streetName}
                    attrName={setStreetName}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title={"Area Name"}
                    value={areaName}
                    attrName={setAreaName}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Country"
                    value={country}
                    attrName={setCountry}
                    value_update={updateMasterState}
                    data={country_data}
                    warn_status={false}
                    error_message="Please select Country"
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="State"
                    value={state}
                    attrName={setState}
                    value_update={updateMasterState}
                    data={state_data}
                    warn_status={false}
                    error_message="Please select State"
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="City"
                    value={city}
                    attrName={setCity}
                    value_update={updateMasterState}
                    data={city_data}
                    warn_status={false}
                    error_message="Please select city"
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title={"Zip Code"}
                    value={zipCode}
                    attrName={setZipCode}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => setAddProperty(false)}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </SlidingPanel>
      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

export default EmployeeDetailProfile;
